export default __webpack_public_path__ + "static/media/student_one.a182b9cc.png";